import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from '../api_service/api.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {JwtHelperService} from "@auth0/angular-jwt";
import {ActivatedRoute, Router} from "@angular/router";
import {CurrentRouteService} from "../currentRoute.service";
import {LoggedinService} from "../loggedin.service";
import {LoggedinServiceBehavior} from "../loggedinbehavior.service";
import {RoleService} from "../role.service";
import {environment} from '../../environments/environment';
import {AuthService, Cognito} from "./auth.service";
import {authReducer} from "./store/auth.reducer";
import {Observable, Subject} from "rxjs";
import {User} from "../shared/models/user.model";

interface postAuthData {
  url: string;
  username: string;
  password: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  myForm: UntypedFormGroup;
  is_form_error: boolean = false;
  form_error_message: string = "";
  is_auth_error: boolean = false;
  is_loading: boolean = false;
  hide = true;
  user = new Subject<User>();

  constructor(
    public router: Router,
    private currentrouteService: CurrentRouteService,
    private route: ActivatedRoute,
    public http: HttpClient,
    private loggedinService: LoggedinService,
    private loggedinServiceBehavior: LoggedinServiceBehavior,
    private roleService: RoleService,
    private _apiService: ApiService,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.roleService.announceRole('')
    console.log('We are trying to login', this.router.url)
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.myForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    })//end myForm
  } //end ngOnInit

  ngOnDestroy() {} //end ngOnDestroy

  onFocus(){
    console.log('onFocus')
    this.is_form_error = false;
    this.form_error_message = null;
  }

  onSubmit() {
    //['AccessToken', 'ExpiresIn', 'IdToken', 'NewDeviceMetadata', 'RefreshToken', 'TokenType']
    this.is_form_error = false;
    let data = this.myForm.value;
    this.is_loading = true
    let url = `${environment['API_URL']}/login`

    let authObs: Observable<Cognito>
    authObs = this.authService.login(url,data['username'],data['password']);
    authObs.subscribe(
      res => {
        //{message: 'Incorrect username or password.', status_code: 400}
        console.log('res', res)
        this.is_loading = false
        if (res['status_code'] == 400) {
          this.is_form_error = true;
          this.form_error_message = res['message']
        } else {
          //navigate to agency from auth.services
          this.router.navigate(['/agencys']);
        } //end if
      },
      errorMessage => {
        this.is_loading = false
        this.is_auth_error = true
        this.is_form_error = true;
        this.form_error_message = 'Incorrect username or password' //res['message']
      },
      () => {
        console.log('auth completed')
      }
    ); //end subscribe


  } //end onSubmit

}
